import {connect} from "react-redux";
import {
  getAllTableCounts,
} from '../actions/actions-reports';
import Reports1 from '../views/Reports/reports1';
const mapStateToProps = (state, ownProps) => {
  return {
    parentProps: ownProps,
    reports: state.reportsR,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getAllTableCounts: () => {
      dispatch(getAllTableCounts() );},
  };
};
const Report1Container = connect(mapStateToProps, mapDispatchToProps)(Reports1);
export default Report1Container;